import React, { useCallback, useEffect, useState } from "react";
import {
  Scroll,
  TrashSimple,
  Plus,
  UploadSimple,
  Funnel,
  CaretUp,
  CaretDown,
} from "phosphor-react";
import TableWrapper from "components/common/table-wrapper";
import { DEBOUNCE_DELAY, initialMetaForTable } from "constants/common";
import CustomModal from "components/common/modal";
import Addmemberform from "./Addmemberform";
import {
  createMember,
  getMembers,
  deleteBulkMember,
  getExportMembers,
  updateMember,
} from "containers/members/api";
import SelectComponent from "components/common/select";
import {
  useNavigate,
  createSearchParams,
  useSearchParams,
} from "react-router-dom";

import {
  highlightFirstMatch,
  capitalizeName,
  formatDate,
  formatString,
} from "utils/common";
import Tooltip from "components/common/tooltip";
import { getTemplates } from "containers/templates/api";
import {
  useDebouncedCaseManagerDataCallback,
  useDebouncedCountiesDataCallback,
  useDebouncedHealthPlansDataCallback,
  useDebouncedHousingNavigatorDataCallback,
  useDebouncedStatesDataCallback,
  useDebouncedTemplateDataCallback,
} from "utils/debouncedHelper";
import AsyncSelect from "components/common/select/AsyncSelect";
import {
  getHealthPlans,
  getStates,
  getCounties,
} from "containers/policies/api";
import { getUserByType } from "containers/users/api";
import MemberFilter from "./filterModal";

let timeout;

const SortableTableHeader = ({
  columnKey,
  label,
  sortConfig,
  onSortChange,
  isSortable, // Receive isSortable prop
}) => {
  const isSorting = sortConfig.key === columnKey;
  const isAscending = isSorting && sortConfig.direction === "asc";
  const isDescending = isSorting && sortConfig.direction === "desc";

  const handleSort = () => {
    if (!isSortable) return; // Only sort if the column allows it
    if (isAscending) {
      onSortChange(columnKey, "desc");
    } else {
      onSortChange(columnKey, "asc");
    }
  };

  return (
    <th
      onClick={handleSort}
      style={{ cursor: isSortable ? "pointer" : "default" }}
    >
      <div className="d-flex position-relative">
        <div className="d-flex flex-column cursor-pointer me-2 position-absolute top-50  end-100 translate-middle-y "></div>
        <div>{label}</div>
        {isSortable && (
          <div className="d-flex flex-column ms-2">
            <CaretUp
              size={12}
              color={isAscending ? "#000000" : "#00000050"}
              weight="fill"
            />
            <CaretDown
              size={12}
              color={isDescending ? "#000000" : "#00000050"}
              weight="fill"
            />
          </div>
        )}
      </div>
    </th>
  );
};
const columns = [
  { columnKey: "name", label: "Member Name", isSortable: true },
  { columnKey: "date_of_birth", label: "DOB", isSortable: false },
  { columnKey: "cin", label: "CIN", isSortable: false },
  { columnKey: "full_address", label: "Address", isSortable: false },
  { columnKey: "health_plan_name", label: "Health Plan", isSortable: true },
  { columnKey: "auth_start_date", label: "Auth Start Date", isSortable: true },
  { columnKey: "auth_end_date", label: "Auth End Date", isSortable: true },
  {
    columnKey: "housing_navigator_name",
    label: "Housing Navigator",
    isSortable: true,
  },
  { columnKey: "cs_manager_name", label: "CSS Manager", isSortable: true },
  { columnKey: "", label: "", isSortable: false },
];
const Member = () => {
  const [membersList, setmembersList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [selectAll, setSelectAll] = useState(false);

  const [templatesList, setTemplatesList] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [meta, setMeta] = useState({
    ...initialMetaForTable,
    mif_status: "active",
    perPage: "10",
  });
  const [loading, setLoading] = useState(true);
  const [selectedmembers, setSelectedmembers] = useState(0);
  const [selectedMember, setSelectedMember] = useState("");
  const [ismemberModalVisible, setmemberIsModalVisible] = useState(false);
  const [isTemplateModalVisible, setIsTemplateModalVisible] = useState(false);
  const [refreshPage, setRefreshPage] = useState(false);
  const [sortConfig, setSortConfig] = useState({
    type: "normal", // or "nested"
    key: "name",
    direction: "asc",
  });
  const [selectedMemberForSurvey, setSelectedMemberForSurvey] = useState("");
  const [isFilterModalVisible, setIsFilterModalVisible] = useState(false);

  const [filters, setFilters] = useState({
    state: null,
    county: null,
    healthPlan: null,
    housingNavigator: null,
    caseManager: null,
  });
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const handleSort = (key) => {
    let direction = "asc";

    if (sortConfig.key === key) {
      direction = sortConfig.direction === "asc" ? "desc" : "asc";
    }

    // 👇 nested sorting handle karo
    if (key === "housing_navigator") {
      setSortConfig({
        type: "normal",
        key: "housing_navigator_name",
        field: "housing_navigator_name",
        direction,
      });
    } else if (key === "care_manager") {
      setSortConfig({
        type: "normal",
        key: "cs_manager_name",
        field: "cs_manager_name",
        direction,
      });
    } else {
      setSortConfig({
        type: "normal",
        key,
        direction,
      });
    }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceFn = (callback, delay) => {
    clearTimeout(timeout);
    timeout = setTimeout(callback, delay);
  };
  const handleSetSearchQuery = (value) => {
    setMeta((pre) => ({ ...pre, search: value }));
    debounceFn(handleRefreshPage, DEBOUNCE_DELAY);
  };
  const handleSetMifFilter = (selectedValue) => {
    setMeta((prevMeta) => ({ ...prevMeta, mif_status: selectedValue }));
    handleRefreshPage();
  };
  const handlePageChange = (value) => {
    navigate({ search: createSearchParams({ page: value }).toString() });
    handleRefreshPage();
  };
  const handleRefreshPage = () => {
    setRefreshPage((pre) => !pre);
  };

  const handlememberSubmission = async (member, setErrors) => {
    try {
      let result = "";
      if (selectedMember) {
        result = await updateMember(member, selectedMember.id, setErrors);
      } else result = await createMember(member, setErrors);
      if (result) {
        handleClosememberModal();
        handleRefreshPage();
      }
    } catch (error) {
      console.log("error is ", error);
    }
  };
  const handleClosememberModal = () => {
    setmemberIsModalVisible(false);
    setSelectedMember("");
  };
  const handleBulkDeleteMembers = async () => {
    const selectedMemberIds = membersList
      ?.filter((member) => member.checked)
      .map((member) => member.id);
    const payload = {
      ids: selectedMemberIds,
    };
    const result = await deleteBulkMember(payload);
    if (result) handleRefreshPage();
  };

  const handleOpenmemberModal = () => {
    setmemberIsModalVisible(true);
  };
  const fetchMembers = useCallback(async () => {
    setLoading(true);
    try {
      const result = await getMembers({
        ...meta,

        page: searchParams.get("page") ? searchParams.get("page") : 1,
        sortConfig,
      });
      if (result["members"]) {
        console.log("members", result["members"]);
        const data = result?.members.map((item) => ({
          ...item,
          name: `${item.first_name || ""} ${item.last_name || ""}`.trim(),
          checked: selectAll,
        }));
        setmembersList(data);
        setTotalCount(result?.meta.total_count);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    refreshPage,
    sortConfig.direction,
    sortConfig.key,
    searchParams.get("page"),
    meta,
  ]);

  const fetchTemplates = useCallback(async () => {
    try {
      const result = await getTemplates(initialMetaForTable);
      if (result["templates"]) {
        const data = result?.templates.map((item) => ({
          label: item.name,
          value: item.id,
        }));
        setTemplatesList(data);
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    fetchMembers();
  }, [meta.filters, refreshPage, sortConfig.key, sortConfig.direction]); // Added sort dependencies to ensure fetch triggers
  // useEffect(() => {
  //   fetchTemplates();
  // }, []);

  useEffect(() => {
    setSelectedmembers(
      selectAll
        ? membersList.length
        : membersList.reduce((accumulator, item) => {
            if (item.checked) {
              return accumulator + 1;
            } else return accumulator;
          }, 0),
    );
  }, [membersList, selectAll]);

  const handleOpenTemplateModal = () => {
    setIsTemplateModalVisible(true);
  };
  const handleCloseTemplateModal = () => {
    setIsTemplateModalVisible(false);
    setSelectedTemplate("");
  };
  const downloadCSV = async () => {
    try {
      const result = await getExportMembers({
        ...meta,
        key: sortConfig.key,
        order: sortConfig.direction,
      });

      const encodedData = result["members_encoded_data"];

      const decodedData = atob(encodedData);

      const blob = new Blob([decodedData], { type: "text/csv" });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "member-data.csv");

      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.error(e);
    }
  };
  const debouncedTemplateCallback = useDebouncedTemplateDataCallback();

  return (
    <>
      <TableWrapper
        searchPlaceholder="Search Members"
        setSearhQuery={handleSetSearchQuery}
        searchValue={meta.search}
        totalListCount={totalCount}
        pageSize={meta.perPage}
        currentPage={
          searchParams.get("page") ? parseInt(searchParams.get("page")) : 1
        }
        onPageChange={handlePageChange}
        selectedItems={selectedmembers}
        isLoading={loading}
        meta={meta}
        setMeta={setMeta}
        handleRefreshPage={handleRefreshPage}
        actionButtons={
          selectedmembers > 0
            ? [
                {
                  label: `Delete ${selectedmembers} Items`,
                  classes: "danger-btn m-0-imp",
                  icon: <TrashSimple size={24} className="me-3" />,
                  handleClick: handleBulkDeleteMembers,
                },
              ]
            : [
                {
                  label: "Filters",
                  classes: "secondary-btn",
                  icon: <Funnel size={24} className="me-3" />,
                  handleClick: () => setIsFilterModalVisible(true),
                },
                {
                  label: "Upload File",
                  classes: "secondary-btn",
                  icon: <UploadSimple size={24} className="me-3" />,
                  handleClick: () => {},
                },

                {
                  label: "Add Members",
                  classes: "primary-btn",
                  icon: <Plus size={24} className="me-3" />,
                  handleClick: handleOpenmemberModal,
                },
              ]
        }
      >
        <div className="container-fluid ">
          <div className=" overflow-scroll">
            <table className="table table-rows ">
              <thead
                className="table-header"
                style={{ backgroundColor: "black" }}
              >
                <tr>
                  {columns.map((column) => (
                    <SortableTableHeader
                      key={column.columnKey}
                      columnKey={column.columnKey}
                      label={column.label}
                      isSortable={column.isSortable}
                      sortConfig={sortConfig}
                      onSortChange={handleSort}
                    />
                  ))}
                </tr>
              </thead>
              <tbody className="table-body">
                {membersList?.map((member, index) => {
                  const homeAddress = member?.addresses?.find(
                    (addr) => addr.address_type === "home",
                  );
                  const addressParts = [
                    homeAddress?.street,
                    homeAddress?.state?.name,
                    homeAddress?.county?.name,
                    homeAddress?.city?.name,
                    homeAddress?.zip_code?.name,
                  ].filter(Boolean);
                  const formattedAddress = addressParts.join(", ");
                  const parseDate = (dateStr) => {
                    if (!dateStr) return null;
                    const [month, day, year] = dateStr.split("/");
                    return new Date(year, month - 1, day);
                  };

                  // const openAuths = Array.isArray(
                  //   member?.expense_authorizations,
                  // )
                  //   ? member.expense_authorizations.filter(
                  //       (auth) =>
                  //         auth.expense_status === "Open" &&
                  //         auth.auth_type === "housing_navigation",
                  //     )
                  //   : [];

                  // let earliestStart = "";
                  // let latestEnd = "";

                  // if (openAuths.length > 0) {
                  //   let minStart = parseDate(openAuths[0].start_date);
                  //   let maxEnd = parseDate(openAuths[0].end_date);

                  //   earliestStart = openAuths[0].start_date;
                  //   latestEnd = openAuths[0].end_date;

                  //   openAuths.forEach((auth) => {
                  //     const start = parseDate(auth.start_date);
                  //     const end = parseDate(auth.end_date);

                  //     if (start && start < minStart) {
                  //       minStart = start;
                  //       earliestStart = auth.start_date;
                  //     }

                  //     if (end && end > maxEnd) {
                  //       maxEnd = end;
                  //       latestEnd = auth.end_date;
                  //     }
                  //   });
                  // }
                  return (
                    <tr key={index}>
                      <td className="fw-bold main-heading">
                        {highlightFirstMatch(member?.name, meta.search)}
                      </td>
                      <td>{formatDate(member?.date_of_birth)}</td>
                      <td>{member?.cin}</td>

                      <td>{formatString(formattedAddress) || ""}</td>

                      <td>{member?.health_plan_name || ""}</td>
                      <td>{member?.auth_start_date || ""}</td>
                      <td>{member?.auth_end_date || ""}</td>

                      <td>
                        {member?.housing_navigator_name || ""}
                      </td>
                      <td>
                        {member?.cs_manager_name || ""}
                      </td>

                      <td className="gap-2">
                        <Tooltip title="History">
                          <Scroll
                            size={24}
                            className="cursor-pointer"
                            onClick={() => {
                              navigate(`/members/${member.id}`);
                              localStorage.setItem(
                                "member",
                                JSON.stringify(member),
                              );
                            }}
                          />
                        </Tooltip>
                        {/* <Tooltip title="Edit">
                        <Pencil
                          size={24}
                          className=" ms-3  cursor-pointer"
                          onClick={() => {
                            setSelectedMember(member);
                            handleOpenmemberModal();
                          }}
                        />
                      </Tooltip> */}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </TableWrapper>
      {ismemberModalVisible && (
        <CustomModal
          size="sm"
          show
          onHide={handleClosememberModal}
          heading={`${selectedMember ? "Edit" : "Add"} Member`}
        >
          <Addmemberform
            handleQuestionSubmittion={handlememberSubmission}
            handleClose={handleClosememberModal}
            selectedMember={selectedMember}
          />
        </CustomModal>
      )}

      {isTemplateModalVisible && (
        <CustomModal
          size="sm"
          show
          onHide={handleCloseTemplateModal}
          heading={`Choose Template`}
        >
          <AsyncSelect
            label="Select Template"
            isRequired
            options={templatesList}
            loadOptions={(inputValue) =>
              new Promise((resolve) => {
                debouncedTemplateCallback(inputValue, resolve);
              })
            }
            selectedValue={selectedTemplate}
            placeholder="Select "
            handleChange={(obj) => {
              setSelectedTemplate(obj);
            }}
          />

          <div className="action gap-2">
            <button
              className="secondary-btn w-50"
              type="button"
              onClick={handleCloseTemplateModal}
            >
              Cancel
            </button>
            <button
              className="primary-btn w-50"
              type="button"
              disabled={!selectedTemplate}
              onClick={() => {
                console.log("selectedTemplate", selectedTemplate);
                navigate(`/survey/${selectedMemberForSurvey.id}`, {
                  state: {
                    ...selectedMemberForSurvey,
                    template_id: selectedTemplate?.value,
                  },
                });
              }}
            >
              Start Survey
            </button>
          </div>
        </CustomModal>
      )}

      {isFilterModalVisible && (
        <CustomModal
          size="sm"
          show
          onHide={() => {
            setIsFilterModalVisible(false);
          }}
          heading={`Filters`}
        >
          <MemberFilter
            filters={filters}
            setFilters={setFilters}
            meta={meta}
            setMeta={setMeta}
            setIsFilterModalVisible={setIsFilterModalVisible}
          />
        </CustomModal>
      )}
    </>
  );
};

export default Member;
